import BlTextAv from './BlTextAv.vue'

BlTextAv.install = function(Vue) {
  Vue.component(BlTextAv.name, BlTextAv)
}

export default BlTextAv
